import { installDiagnostics, recordInitFailure } from './diagnostics';
import { init, readInitOptionsFromScriptTag } from './init';
import type { WebChatApi } from './types';

declare global {
  interface Window {
    _webChat?: WebChatApi;
  }
}

// Install diagnostics *before* init so a bootstrap failure still leaves
// window.__ST_WEBCHAT__.diagnose() usable.
installDiagnostics();

// UMD entry point for the <script>-tag consumer. Reads data-tenant-id /
// data-agent-id off the tag with the fixed embed script id and exposes the
// resulting API as the window._webChat global.
try {
  const options = readInitOptionsFromScriptTag();
  window._webChat = init(options);
} catch (error) {
  recordInitFailure(error);
  console.error('web-chat-embed: failed to initialize', error);
}
